// src/components/VideoPlayer.js   ← plain .js file, works everywhere
import React from 'react';

function VideoPlayer({ url, className }) {
  // Default class if none passed
  const defaultClass = "w-full aspect-video";
  const finalClass = className ? `${className} rounded-xl` : `${defaultClass} rounded-xl`;

  const isYouTube = url && (
    url.includes('youtube.com/embed') || 
    url.includes('youtu.be')
  );

  if (isYouTube) {
    return (
      <iframe
        src={url}
        className={finalClass}
        allowFullScreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        loading="lazy"
        title="Provider video"
      />
    );
  }

  // Old local MP4 fallback
  return (
    <video 
      controls 
      className={finalClass} 
      preload="metadata"
      title="Provider video"
    >
      <source src={url} type="video/mp4" />
      Your browser does not support video.
    </video>
  );
}

export default VideoPlayer;
